/* eslint-disable max-len */
export const transitionType = [
  {
    class: 'fadeIn',
    name: 'Fade in',
  },
  {
    class: 'spinner',
    name: 'Spinner',
  },
  {
    class: 'moveDown',
    name: 'Move Down',
  },
  {
    class: 'moveUp',
    name: 'Move Up',
  },
  {
    class: 'moveLeftToRight',
    name: 'Move Right',
  },
  {
    class: 'moveRightToLeft',
    name: 'Move Left',
  },
  {
    class: 'slideIn',
    name: 'Slide In',
  },
];

export const bannerType = [
  {
    id: 1,
    name: 'Type 1',
  },
  {
    id: 2,
    name: 'Type 2',
  },
  {
    id: 3,
    name: 'Type 3',
  },
];

export const encryptedKeyForCredentials = {
  password: 'RpML0qe+o6atUKszlp7YmckLjX2uIR8sNyvxiTwlYOE=',
  email: 'IoJd4EcEZWigNoiSV1JzKp9dnw5ualsg1YpUxwZygu0=',
  mobile: 'SVuq5XhuNX491KJ9DTVyzHvQ8OyjCZEkmRTZn1Jf+pE=',
};

export const ALLOWED_UPLOADS_COUNT = 15;
// Hard cap on how many photos may ride in a single upload flow. Past this the
// picker drops the extras and tells the user — an album can be topped up with
// further uploads, so nothing is permanently out of reach.
export const MAX_PHOTOS_PER_UPLOAD = 1000;
export const MAX_FREE_SIZE_GB = 15;
// TODO change key to env
export const GOOGLE_RECAPTCHA_KEY = '6Lc2vFgoAAAAAN7M6Qh2CrW2RJQYXlwOSCojWXRT';
export const CLOUDFLARE_TURNSTILE_SITE_KEY = '0x4AAAAAAB947200DAWaN-MF';

export const PLANS = {
  free: 'Free',
  best: 'Best',
};
